module.exports = __webpack_public_path__ + "img/logo-h.bfb6deba.png";